import { render, staticRenderFns } from "./ToDoPurchaseYiXinApplicationSelect.vue?vue&type=template&id=4d0e8677"
import script from "./ToDoPurchaseYiXinApplicationSelect.vue?vue&type=script&lang=js"
export * from "./ToDoPurchaseYiXinApplicationSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports